import React from "react";
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import EmailIcon from '@mui/icons-material/Email';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';



// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();



const Scrivici = () => {



  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <EmailIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            <a href="mailto:voltosantonapoli@gmail.com?subject=Messaggio dal Sito">Scrivici</a>
          </Typography>
          
        </Box>
      </Container>
    </ThemeProvider>
  )
};

  
export default Scrivici;